export const version = '2.47.6';
//# sourceMappingURL=version.js.map